import bikeCheckpointsGeojson from '../../assets/maptiler/2026/ironman-bike-checkpoints.geojson';
import bikeCourseGeojson from '../../assets/maptiler/2026/ironman-bike-course.geojson';
import runningCheckpointsGeojson from '../../assets/maptiler/2026/ironman-running-checkpoints.geojson';
import runningCourseGeojson from '../../assets/maptiler/2026/ironman-running-course.geojson';
import swimmingCourseGeojson from '../../assets/maptiler/2026/ironman-swimming-course.geojson';

export class Sources {
    static bikeCourse = () => {
        return Sources._getSourceFromJsonString(bikeCourseGeojson);
    };

    static bikeCheckpoints = () => {
        return Sources._getSourceFromJsonString(bikeCheckpointsGeojson);
    };

    static runningCourse = () => {
        return Sources._getSourceFromJsonString(runningCourseGeojson);
    };

    static runningCheckpoints = () => {
        return Sources._getSourceFromJsonString(runningCheckpointsGeojson);
    };

    static swimmingCourse = () => {
        return Sources._getSourceFromJsonString(swimmingCourseGeojson);
    };

    static _getSourceFromJsonString(jsonString) {
        return {
            type: 'geojson',
            data: JSON.parse(jsonString),
        };
    }
}
